import constants from './constants';

const initState = {
  isDrawing: false,
//   geofencesData: null,
//   offset: 0,
//   limit: 40,
//   hasMore: true,
//   search: '',
//   geofenceToEdit: null,
//   geometryPolygon: null,
};

function geofencesReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.RESET_STATE:
      return initState;

    case constants.SET_IS_DRAWING:
      return {
        ...state,
        isDrawing: payload,
      };

      //     case constants.SET_SEARCH_GEOMETRY_POLYGON:
      //       return {
      //         ...state,
      //         search: payload,
      //         offset: 0,
      //         geofencesData: null,
      //       };

      //     case constants.SET_GEOFENCES_DATA:
      //       return {
      //         ...state,
      //         geofencesData: payload.data,
      //         offset: payload.offset,
      //         hasMore: payload.hasMore,
      //       };

      //     case constants.SET_GEOFENCE_TO_EDIT:
      //       return {
      //         ...state,
      //         geofenceToEdit: payload,
      //         isDrawing: payload ? true : state.isDrawing,
      //       };

      //     case constants.SET_GEOMETRY_POLYGON:
      //       return {
      //         ...state,
      //         geometryPolygon: payload,
      //       };

      //     case constants.ADD_MULTIPLES_GEOFENCES:
      //       return {
      //         ...state,
      //         geofencesData: payload,
      //       };

      //     case constants.CREATE_GEOMETRY_POLYGON:
      //     case constants.UPDATE_GEOMETRY_POLYGON:
      //       return {
      //         ...state,
      //         geofencesData: payload,
      //         isDrawing: false,
      //         geofenceToEdit: null,
      //       };

      //     case constants.DELETE_GEOMETRY_POLYGON:
      //       return {
      //         ...state,
      //         geofencesData: payload,
      //       };

    default:
      return state;

  }

}

export default geofencesReducer;
